import * as React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import routes from './routes';
import Layout from './components/layout';
import LayoutPublic from './components/layoutPublic';
import StateContext from './context/UserProvider';
import { ScreenProvider } from './context/LockScreenProvider';
import LayoutClosedSession from './components/layoutClosedSession';
import { useTranslation } from 'react-i18next';

function App() {
  const { status } = StateContext();
  const { t } = useTranslation<["translation"]>(["translation"]);

  if (status === "checking") return <div className="loading">{t("checkingCredentials")}</div>

  return (
    <>
      <BrowserRouter>
        <ScreenProvider>
          <React.Suspense fallback={<div>{t("loading")}</div>}>
            <Routes>
              {
                status === "authenticated" ?
                  <Route path="/" element={<Layout />}>
                    {routes}
                  </Route>
                  : (
                    status === "closed-session" ?
                      <Route path="/" element={<LayoutClosedSession />} />
                      : <Route path="/" element={<LayoutPublic />} />
                  )
              },
              <Route path='*' element={<Navigate to='/404' replace />} />
            </Routes>
          </React.Suspense>
        </ScreenProvider>
      </BrowserRouter>
    </>
  );
}

export default App;
